<div class="loader-container">
  <div class="spinner-border" role="status" aria-live="polite">
    <span class="visually-hidden">{{ 'loading_spinner_text' | translate }}</span>
  </div>
  <p>{{ 'loading_spinner_text' | translate }}</p>
</div>
